import { render, staticRenderFns } from "./site-content.vue?vue&type=template&id=6265052f"
import script from "./site-content.vue?vue&type=script&lang=js"
export * from "./site-content.vue?vue&type=script&lang=js"
import style0 from "./site-content.vue?vue&type=style&index=0&id=6265052f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports